import {openPanelInModal} from '@Components/modal-container/modal-container-reducer';
import {MODALS_IDS} from '@Components/modal-container';
import type {SocialMediaSelectCoverModalProps} from '@Modals/social-media-select-cover-modal/social-media-select-cover-modal.types';

export const openSelectCoverModal = (props: SocialMediaSelectCoverModalProps): void => {
  window.PMW.redux.store.dispatch(
    openPanelInModal({
      modalId: MODALS_IDS.SOCIAL_MEDIA_SELECT_COVER_MODAL,
      panelProps: props,
    })
  );
};
